var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReplayIcon(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.3,
    height: 56.53,
    viewBox: "0 0 50.3 56.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.57,6.24V0L13.23,9.23l12.34,9.23v-6.21c10.36,.23,18.73,8.71,18.73,19.13s-8.59,19.15-19.15,19.15S6,41.94,6,31.38H0c0,13.87,11.28,25.15,25.15,25.15s25.15-11.28,25.15-25.15S39.24,6.46,25.57,6.24Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplayIcon);
export default __webpack_public_path__ + "static/media/replay-icon.9c6e7d0293d5e1e2032aa0a40dd40566.svg";
export { ForwardRef as ReactComponent };